import {
  BaseActionObject,
  NoInfer,
  ResolveTypegenMeta,
  ServiceMap,
  StatesConfig,
} from "xstate";
import { MiddleWareFinalState } from "./final";
import { MiddleWareServices } from ".";
import { MachineOptionsServices } from "../types/services.type";
import { CustomEventObject } from "../types/types";

export class MiddleWareOptionsModel {
  public stateFinalConfig<
    Context,
    EventType extends CustomEventObject,
    Action extends BaseActionObject
  >(
    states:
      | StatesConfig<NoInfer<Context>, any, NoInfer<EventType>, Action>
      | undefined
  ) {
    const statesResult = MiddleWareFinalState<Context, EventType, Action>(
      states
    );
    return {
      states: statesResult,
    };
  }
  public options<
    Context,
    EventType extends CustomEventObject,
    Action extends BaseActionObject
  >(
    services: MachineOptionsServices<
      Context,
      ResolveTypegenMeta<any, EventType, Action, ServiceMap>,
      any,
      any,
      any
    >
  ) {
    const serviceResult = MiddleWareServices<Context, EventType, any>(services);
    return {
      middleServices: serviceResult,
    };
  }
}
